<template>
  <vue-header-b2b
    v-if="headerVersionDefault"
    :categorias="categorias"
    :logo="logo"
    :logoUrl="logoUrl"
    :logoDarkUrl="logoDarkUrl"
    :acessosEmpresa="$empresaUtils"
    :tiposAcesso="$tipoAcesso"
    :configEmpresa="$configEmpresa"
    :t="$t"
    :router="$router"
    :exibirBarraBuscaHeader="exibirBarraBuscaHeader"
    :avatar="avatar"
    :avatarPadrao="avatarPadrao"
    :usuario="usuario"
    :temPermissaoAdmin="temPermissaoAdmin"
    :modoNoturno="modoNoturno"
    @SSOBibliotecaA="SSOBibliotecaA"
    @logout="logout"
    @redirectToWL="redirectToWL"
    @redirectToCms="redirectToCms"
    @alternarDarkMode="alternarDarkMode"
    @buscaGeralPlataforma="buscaGeralPlataforma"
  >
    <notificacoes></notificacoes>
  </vue-header-b2b>
  <vue-header-b2b-20
    v-else
    :categorias="categorias"
    :logo="logo"
    :logoUrl="logoUrl"
    :logoDarkUrl="logoDarkUrl"
    :acessosEmpresa="$empresaUtils"
    :tiposAcesso="$tipoAcesso"
    :configEmpresa="$configEmpresa"
    :t="$t"
    :router="$router"
    :exibirBarraBuscaHeader="exibirBarraBuscaHeader"
    :avatar="avatar"
    :avatarPadrao="avatarPadrao"
    :usuario="usuario"
    :temPermissaoAdmin="temPermissaoAdmin"
    :modoNoturno="modoNoturno"
    @SSOBibliotecaA="SSOBibliotecaA"
    @logout="logout"
    @redirectToWL="redirectToWL"
    @redirectToCms="redirectToCms"
    @alternarDarkMode="alternarDarkMode"
    @buscaGeralPlataforma="buscaGeralPlataforma"
  >
  <notificacoes></notificacoes>
  </vue-header-b2b-20>
</template>

<script>
import LoginUtils from '@/core/utils/login-utils'
import ImageUtils from '@/core/utils/image-utils'
import UsuarioAPI from '@/api/usuario-api'
import AcessoSSOAPI from '@/api/acesso-sso-api'
import CategoriaAPI from '@/api/categorias-api'
import { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import md5 from 'js-md5'
import VueHeaderB2b from 'VueHeaderJaleko/src/vue-header-b2b.vue'
import VueHeaderB2b20 from 'VueHeaderJaleko/src/vue-header-b2b-20.vue'
import Constants from '@/core/constants/constants'
import Notificacoes from './Notificacoes.vue'
import 'VueHeaderJaleko/src/scss/vue-header-b2b.scss'

export default {
  name: 'AppHomeHeader',
  components: {
    VueHeaderB2b,
    VueHeaderB2b20,
    Notificacoes
  },
  data () {
    return {
      logo: {},
      logoUrl: `${process.env.VUE_APP_BASE_FILES_URL}empresas/logos/${process.env.VUE_APP_EMPRESA_REF}/light.png`,
      logoDarkUrl: `${process.env.VUE_APP_BASE_FILES_URL}empresas/logos/${process.env.VUE_APP_EMPRESA_REF}/dark.png`,
      showJaleklinicoHeader: false,
      usuario: { name: '', email: '', avatar: '' },
      termoPesquisa: '',
      version: '',
      modoNoturno: false,
      avatar: '',
      professoresJalekoEmpresaId: 23,
      exibirBarraBuscaHeader: true,
      categorias: []
    }
  },
  created () {
    this.logo = this.$configEmpresa.logo
    this.version = process.env.PACKAGE_VERSION
    this.menuBackgroundColor = this.$configEmpresa.menuBackgroundColor ? this.$configEmpresa.menuBackgroundColor : '#363953'
    this.avatar = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/avatar.png`
    this.termoPesquisa = this.$route.query.q
  },
  mounted () {
    this.usuario = LoginUtils.getUsuario()

    if (LoginUtils.getUsuario().modo_noturno === 1) {
      this.modoNoturno = true
    } else {
      this.modoNoturno = false
    }

    CategoriaAPI.listarDisciplinas().then(data => {
      this.categorias = data.categorias
    })
  },
  watch: {
    modoNoturno: function () {
      let usuario = JSON.parse(localStorage.getItem('usuario'))
      if (this.modoNoturno) {
        usuario.modo_noturno = 1
        document.body.classList.add('darkMode')
      } else {
        usuario.modo_noturno = 0
        document.body.classList.remove('darkMode')
      }
      localStorage.setItem('usuario', JSON.stringify(usuario))
      this.$store.dispatch('alternaModoNoturno', this.modoNoturno)
    },
    $route: function () {
      if (
        this.$route.name === 'ferramentas' ||
        (this.$route.name === 'HomeApp' &&
          this.$configEmpresa.homeVersion !== Constants.HOME_VERSION_DEFAULT)
      ) {
        this.exibirBarraBuscaHeader = false
      } else {
        this.exibirBarraBuscaHeader = true
      }
    }
  },
  computed: {
    avatarPadrao: function () {
      if (this.usuario && this.usuario.avatar) {
        return ImageUtils.obterUrlCompletaImagem(this.usuario.avatar)
      }
      return ''
    },
    exibeMenuCurso: function () {
      return this.$store.getters.getMenuCursoState
    },
    temPermissaoAdmin: function () {
      if (TipoPerfilUtil.isMaster(this.usuario.perfil_id) || TipoPerfilUtil.isAdmin(this.usuario.perfil_id) || TipoPerfilUtil.isAdminRestrito(this.usuario.perfil_id) || TipoPerfilUtil.isMasterJaleko(this.usuario.perfil_id) || TipoPerfilUtil.isProfessor(this.usuario.perfil_id) || TipoPerfilUtil.isAnalista(this.usuario.perfil_id)) {
        return true
      } else {
        return false
      }
    },
    configEmpresa: function () {
      return this.$store.getters.empresa
    },
    headerVersionDefault: function () {
      return this.$configEmpresa.headerVersion === Constants.HEADER_VERSION_DEFAULT
    }
  },
  methods: {
    exibeMenu () {
      this.$store.dispatch('alternaMenuCurso')
    },
    logout: function () {
      LoginUtils.logout()
      localStorage.removeItem('uuidLs')
      window.location = '/login'
    },

    alternarDarkMode () {
      this.modoNoturno = !this.modoNoturno
      UsuarioAPI.alternarDarkMode()
    },

    buscaGeralPlataforma: function (termo) {
      this.$store.dispatch('buscaGeralPlataforma', termo)
      this.$router.push(`/busca?q=${termo}`)
    },

    redirectToCms: async function () {
      let token = await AcessoSSOAPI.tokenSSO()
      window.open(process.env.VUE_APP_JALEKO_CMS_URL + '/login/token/' + token + '?empresaId=' + process.env.VUE_APP_EMPRESA_REF, '_blank')
    },

    redirectToWL: async function () {
      let url = await AcessoSSOAPI.tokenWLSSO(this.professoresJalekoEmpresaId)
      window.open(url, '_blank')
    },

    SSOBibliotecaA: function () {
      let sharedSecret = process.env.VUE_APP_BIBLIOTECA_A_SHARED_SECRET
      let consumerKey = process.env.VUE_APP_BIBLIOTECA_A_CONSUMER_KEY

      let usuario = JSON.parse(localStorage.getItem('usuario'))
      let queryStr = 'consumerkey=' + consumerKey + '&userId=' + usuario.id + '&name=' + encodeURIComponent(usuario.name) + '&email=' + encodeURIComponent(usuario.email)
      let formatYmd = (new Date()).toISOString().slice(0, 10).replaceAll('-', '')
      let mac = md5(sharedSecret + formatYmd + queryStr)
      queryStr = queryStr + '&tok=' + mac
      window.open(process.env.VUE_APP_BIBLIOTECA_A_URL + '/lti/launch.php?' + queryStr, '_blank')
    }
  }
}
</script>

<style scoped>

</style>
